import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
var ModalComp = function (props) {
    var header = props.header, content = props.content, buttonContent = props.buttonContent, confirmLabel = props.confirmLabel, isModalOpen = props.isModalOpen, cancelLabel = props.cancelLabel, handleSubmit = props.handleSubmit, handleClose = props.handleClose, hideFooter = props.hideFooter, wrapClassName = props.wrapClassName, modalClassName = props.modalClassName, contentClassName = props.contentClassName;
    var _a = useState(isModalOpen), isOpen = _a[0], setIsOpen = _a[1];
    useEffect(function () {
        setIsOpen(isModalOpen);
    }, [isModalOpen]);
    var toggle = function () {
        handleClose();
        setIsOpen(!isOpen);
    };
    return (React.createElement(React.Fragment, null,
        buttonContent && React.createElement(Button, { onClick: toggle }, buttonContent),
        React.createElement(Modal, { isOpen: isOpen, toggle: toggle, wrapClassName: wrapClassName, modalClassName: modalClassName, contentClassName: contentClassName },
            header && React.createElement(ModalHeader, { toggle: toggle }, header),
            React.createElement(ModalBody, null, content),
            !hideFooter && (React.createElement(ModalFooter, null,
                React.createElement(Button, { color: "primary", onClick: handleSubmit }, confirmLabel),
                ' ',
                React.createElement(Button, { color: "secondary", onClick: toggle }, cancelLabel))))));
};
export default ModalComp;
